import { useState } from "react";
import { toast } from "sonner";
import { Youtube, Plus } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { field, Label } from "../formBits";
import { newTrack } from "./trackBits";

// Paste one YouTube / YouTube Music song link and drop it straight into the queue.
export const QuickYouTube = ({ onAdd }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async () => {
    if (!/youtu/.test(url)) { toast.error("Paste a YouTube or YouTube Music song link."); return; }
    setBusy(true);
    try {
      const { data } = await api.get("/music/source", { params: { url } });
      onAdd(data.tracks.map(newTrack));
      toast.success(data.tracks.length === 1 ? `ADDED "${data.tracks[0].title}" — SAVE TO PUBLISH` : `ADDED ${data.tracks.length} TRACKS — SAVE TO PUBLISH`);
      setUrl("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2" data-testid="music-quick-youtube">
      <Label>ADD MY OWN YOUTUBE SONG</Label>
      <div className="flex gap-2">
        <input data-testid="music-quick-youtube-input" value={url} onChange={(e) => setUrl(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder="https://youtu.be/...  or  https://music.youtube.com/watch?v=..." className={field} />
        <button type="button" data-testid="music-quick-youtube-add" onClick={add} disabled={busy || !url.trim()}
          className="shrink-0 flex items-center gap-2 px-4 border border-[#FF2A55]/60 text-[#FF2A55] font-mono text-[11px] font-bold tracking-[0.2em] hover:bg-[#FF2A55] hover:text-black disabled:opacity-50">
          {busy ? "ADDING..." : <><Youtube size={14} /> <Plus size={12} /> ADD</>}
        </button>
      </div>
    </div>
  );
};
